import axios from 'axios';

const GO_PLUS_TOKEN_ENDPOINT =
  'https://api.gopluslabs.io/api/v1/token_security';

type BoolString = '0' | '1';

interface DexDetail {
  name: string;
  liquidity: string;
  pair: string;
}

interface Holder {
  address: string;
  tag: string;
  is_contract: BoolString;
  balance: string;
  percent: string;
  is_locked: BoolString;
}

export interface IGoPlusTokenData {
  anti_whale_modifiable: BoolString;
  buy_tax?: string;
  can_take_back_ownership?: BoolString;
  cannot_buy?: BoolString;
  cannot_sell_all?: BoolString;
  creator_address: string;
  creator_balance?: string;
  creator_percent?: string;
  dex: DexDetail[];
  external_call?: BoolString;
  hidden_owner?: BoolString;
  holder_count: string;
  holders: Holder[];
  honeypot_with_same_creator?: BoolString;
  is_anti_whale: BoolString;
  is_true_token?: BoolString; ///
  is_airdrop_scam?: BoolString; ///
  trust_list?: BoolString;
  other_potential_risks?: BoolString;
  is_blacklisted?: BoolString; //
  is_honeypot?: BoolString; //
  is_in_dex: BoolString;
  is_mintable: BoolString;
  is_open_source: BoolString;
  is_proxy?: BoolString;
  is_whitelisted?: BoolString;
  lp_holder_count?: string;
  lp_holders?: Holder[];
  lp_total_supply?: string;
  owner_address?: string;
  owner_balance?: string;
  owner_change_balance?: string;
  owner_percent?: string;
  personal_slippage_modifiable?: BoolString;
  selfdestruct?: BoolString;
  sell_tax?: string;
  slippage_modifiable?: BoolString;
  token_name: string;
  token_symbol: string;
  total_supply?: string;
  note?: string;
  trading_cooldown?: BoolString;
  transfer_pausable?: BoolString;
}

interface IGoPlusTokenResponse {
  code: number;
  message: string;
  result: {
    [address: string]: IGoPlusTokenData | undefined;
  };
}

const getGoPlusTokenInfo = async (
  chainId: number,
  address: string,
  controller?: AbortController
): Promise<IGoPlusTokenData | null> => {
  try {
    const url = `${GO_PLUS_TOKEN_ENDPOINT}/${chainId}`;
    const { data } = await axios.get<IGoPlusTokenResponse>(url, {
      params: { contract_addresses: address },
      signal: controller?.signal,
    });
    if (data.code !== 1 || !data.result[address.toLowerCase()]) {
      console.warn(data.message);
      return null;
    }
    return data.result[address.toLowerCase()] || null;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export { getGoPlusTokenInfo };
